var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"vb-text-editor",class:{
    'has-bottom-border': _vm.bottomBorder,
    seamless: _vm.seamless,
    'is-bordered': _vm.isBordered,
  },domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})}
var staticRenderFns = []

export { render, staticRenderFns }